
import { Component, Vue } from 'vue-property-decorator';
import {
  WebsocketDialogMessage,
  WebsocketNotificationInterface,
  WebsocketRoleUpdatedMessage,
} from '@/services/WS/interfaces';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import { UserLoginPayloadWSMessage } from '@/services/Auth/Interfaces';

@Component({
  sockets: {
    async notification(notification: WebsocketNotificationInterface): Promise<void> {
      this.$notifications[notification.level](notification.title, notification.body);
      this.$store.commit('SOCKET_notification', notification);
    },
    dialog(message: WebsocketDialogMessage): void {
      switch (message.type) {
        case 'success':
          return this.$successDialog.show(message.message)
        case 'error':
          return this.$errorDialog.show(message.message)
        case 'info':
          return this.$infoDialog.show(message.message)
      }
    },
    async forceLogout(): Promise<void> {
      this.$store.commit('USER_LOGOUT');
      this.$socket.disconnect();
      await this.$router.push({ name: 'auth_login' });
      this.$notifications.info('FORCE LOGOUT', 'You have been logged out, please login again.');
    },
    async roleUpdated(message: WebsocketRoleUpdatedMessage): Promise<void> {
      this.$store.commit('UPDATE_SCOPES', message.scopes);
      this.$notifications.info('Your Permissions Has Been Updated');
    },
    async updateCredentials(message: UserLoginPayloadWSMessage): Promise<void> {
      this.$store.commit('USER_LOGOUT');
      this.$socket.io.opts.query = { key: message.jwt };
      message.id = message.user;
      this.$store.commit('USER_LOGIN', message);
      this.$socket.connect();
      this.$notifications.info('Your Role Has Been Changed');
      this.$emit('UPDATED_CREDENTIALS', message.id);
    },
  },
  inject: [
    'profileRepository',
  ],
})
export default class App extends Vue {
  private readonly profileRepository!: ProfileRepositoryInterface;

  private async beforeCreate(): Promise<void> {
    if (localStorage.getItem('vuex') && JSON.parse(localStorage.getItem('vuex') as string).user.jwt !== undefined) {
      const { data } = await this.$http.get('/auth/validate');
      if (!data.valid) {
        this.$store.commit('USER_LOGOUT');
        await this.$router.push({ name: 'auth_login' });
      }
    }

    this.$vuetify.theme.dark = this.$store.getters.darkTheme;

    this.$on('UPDATED_CREDENTIALS', async (userId: string) => {
      const profile = await this.profileRepository.getBaseProfileDataByUserId(userId);
      if (profile) {
        this.$store.commit('SET_NAME', `${profile.firstName} ${profile.lastName}`);
      }
    });
  }

  private async created(): Promise<void> {
    if (!this.$store.getters.id) {
      return;
    }
  }
}
